import React from 'react';
import { createRoot } from 'react-dom/client';
import Workspace from './components/Workspace';
import './style.css';
import config from './config/config.json';

const gaId = (config as { enabledModules?: { general?: { googleAnalytics?: { ID?: string } } } }).enabledModules?.general?.googleAnalytics?.ID;
if (gaId) {
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  document.head.appendChild(script);
  (window as any).dataLayer = (window as any).dataLayer || [];
  const gtag = (...args: any[]) => ((window as any).dataLayer).push(args);
  (window as any).gtag = gtag;
  gtag('js', new Date());
  gtag('config', gaId);
}

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <Workspace />
    </React.StrictMode>
  );
}
